import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useMemo } from 'react';

import { DashboardWelcomeState } from '@/features/dashboard/components/dashboard-welcome-state';
import { getDashboardWelcomeConsumedKey, parseBuildMode, parseWelcomeFlag } from '@/features/dashboard/welcome-state';
import { useCurrentOrganizationId } from '@/features/organizations/store/useCurrentOrganizationStore';

export const Route = createFileRoute('/_app/dashboard')({
    validateSearch: (search: Record<string, unknown>) => ({
        welcome: parseWelcomeFlag(search.welcome),
        buildMode: parseBuildMode(search.buildMode)
    }),
    component: DashboardRoute
});

function DashboardRoute() {
    const navigate = useNavigate();
    const { welcome, buildMode } = Route.useSearch();
    const organizationId = useCurrentOrganizationId();

    const shouldShowWelcome = useMemo(() => {
        if (!welcome) {
            return false;
        }

        return window.sessionStorage.getItem(getDashboardWelcomeConsumedKey(organizationId)) !== '1';
    }, [organizationId, welcome]);

    useEffect(() => {
        if (shouldShowWelcome) {
            return;
        }

        void navigate({ to: '/organizations', replace: true });
    }, [navigate, shouldShowWelcome]);

    if (!shouldShowWelcome) {
        return null;
    }

    return <DashboardWelcomeState buildMode={buildMode} organizationId={organizationId} />;
}
